import React, { useState, useContext, useEffect, useRef } from "react";

import { makeStyles } from "@material-ui/core/styles";
import TabSearchbar from "../TabSearchbar";
import CoinList from "../List";
// import { icons } from "../../assets/icons/coinIcons.js";
import { Button, Divider } from "@material-ui/core";
import { useSelector } from "react-redux";
import useResizer from "../../services/useResizer";
import useSWR from "swr";
import fetcher from "../../api/swr_fetcher";
import { useFirstRender } from "../../services/useFirstRender";

// const originalOrder = [...icons];

export default function CurrencyTabs(props) {
  const classes = useStyles();
  const initialRender = useFirstRender();

  // var listLS = JSON.parse(localStorage.getItem("list"));

  const [searchText, setSearchText] = useState("");
  // const [coinList, setCoinList ] = useState([])
  // const [favCoinList, setFavCoinList] = useState([])
  const [filteredData, setFilteredData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [iconData, setIconData] = useState([]);
  const [originalOrder, setOriginalOrder] = useState([]);
  const [icons, setIcons] = useState([]);

  const [orderAZ, setOrderAZ] = useState(false);
  const [orderPrice, setOrderPrice] = useState(false);

  var drawerOpen = props.position;
  var tab = props.tab;

  const isMobile = useResizer();

  const prices = useSelector((state) => state.priceReducer.PRICES);
  useEffect(() => {
    fetchCoinConfig();
    // initialRender.current = false;
  }, []);

  // useEffect(() => {
  //   if (!initialRender)
  //   console.log("R", Date.now());
  // }, [prices]);

  const fetchCoinConfig = (e) => {
    fetcher(`/v1/coinConfig`).then((data) => {
      const sortedArrayByMarketCap = sort_by_key_descending(
        [...data],
        "marketCap"
      );
      setOriginalOrder(sortedArrayByMarketCap);
      setIcons(sortedArrayByMarketCap);
    });
  };

  const handleSearch = (e) => {
    const val = e.target.value;
    setSearchText(val);

    // originalorder
    const searchedList = originalOrder.filter(function (item) {
      return (
        item.coinId.toLowerCase().search(val.toLowerCase()) !== -1 ||
        item.coinName.toLowerCase().search(val.toLowerCase()) !== -1
      );
    });
    setFilteredData(searchedList);
  };

  function handleAZSort() {
    if (!orderAZ) {
      const sortedByAZ = sort_by_key_ascending([...originalOrder], "coinId");
      setIcons(sortedByAZ);
    } else {
      setIcons(originalOrder);
    }
  }

  function handlePriceSort() {
    let valueA;
    let valueB;
    if (!orderPrice) {
      const sortedByPrice = [...icons].sort(function (a, b) {
        if (!prices[`${a.coinId}INR`]) {
          valueA = 0;
        } else {
          valueA = prices[`${a.coinId}INR`]["a"];
        }
        if (!prices[`${b.coinId}INR`]) {
          valueB = 0;
        } else {
          valueB = prices[`${b.coinId}INR`]["a"];
        }
        return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
      });

      setIcons(sortedByPrice);
    } else {
      setIcons(originalOrder);
    }
  }

  function sort_by_key_descending(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return y - x;
    });
  }
  function sort_by_key_ascending(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }
  return (
    <div
      className={classes.root}
      style={{ marginTop: !isMobile ? "-8px" : "5px" }}
    >
      {drawerOpen ? (
        <div className={classes.filterContainer}>
          <TabSearchbar value={searchText} onChange={handleSearch} />
          <div
            style={{
              margin: 0,
              fontWeight: "bold",
              alignItems: "right",
              marginTop: "5px", //10px
              marginBottom: "5px", //10px
              display: "flex",
            }}
          >
            {/* <p style={{ margin: 0, paddingTop: "8px" }}>Order By:</p> */}
            <Button
              onClick={() => {
                setOrderAZ(!orderAZ);
                handleAZSort();
              }}
              variant={orderAZ ? "contained" : "outlined"}
              style={{
                padding: "2px",
                fontSize: "13px",
                width: "45px",
                height: "20px", //30px
                marginTop: "3px",
                marginRight: "10px",
                color: orderAZ ? "white" : null,
                fontWeight: orderAZ ? "bold" : null,
              }}
              color="primary"
              disabled={prices ? false : true}
            >
              A-Z
            </Button>
            <div className={classes.grow} />
            <Button
              onClick={() => {
                setOrderPrice(!orderPrice);
                handlePriceSort();
              }}
              variant={orderPrice ? "contained" : "outlined"}
              style={{
                padding: "6px",
                fontSize: "13px",
                width: "45px",
                height: "20px", //30px
                marginTop: "3px",
                color: orderPrice ? "white" : null,
                fontWeight: orderPrice ? "bold" : null,
              }}
              color="primary"
              disabled={prices ? false : true}
            >
              Price
            </Button>
            {/* <div className={classes.grow} />
            <Button
              variant="outlined"
              style={{
                padding: "6px",
                fontSize: "13px",
                width: "45px",
                height: "30px",
                marginTop: "3px",
              }}
              color="primary"
            >
              Change
            </Button> */}
          </div>
        </div>
      ) : null}

      {iconData !== [] ? (
        <CoinList
          data={searchText.length ? filteredData : icons}
          tab={tab}
          position={drawerOpen}
        />
      ) : null}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: "100%",
    paddingLeft: "!0px",
  },
  grow: {
    flexGrow: 1,
  },
  buttonStyle: {
    margin: 0,
  },
  filterContainer: {
    marginTop: "0px", //24px
    paddingLeft: "20px",
    paddingRight: "20px",
    // paddingBottom: "5px",
    borderWidth: "1px",
    borderBottomStyle: "solid",
    borderColor: theme.palette.type === "dark" ? "#383A47" : "#E4E4E4",
  },
}));
